export default function PricingSection() {
  return (
    <section className="py-20 md:py-28 bg-white" id="pricing" style={{scrollMarginTop:'64px'}}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-[#1a56db] text-sm px-4 py-2 rounded-full mb-4 font-medium">
            <i className="ri-vip-crown-fill"></i>
            <span>会员方案</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#0d2d6e] mb-4">选择适合家庭的方案</h2>
          <p className="text-gray-500 text-lg">解锁全部功能，陪伴孩子不设限</p>
        </div>
        <div className="flex flex-col md:flex-row gap-6 max-w-3xl mx-auto">
          <div className="flex-1 border border-gray-100 rounded-3xl p-8" style={{boxShadow:'0 2px 16px rgba(0,0,0,0.05)'}}>
            <div className="mb-6">
              <span className="bg-gray-100 text-gray-500 text-xs font-medium px-3 py-1 rounded-full">免费版</span>
            </div>
            <div className="mb-6">
              <span className="text-5xl font-black text-[#0d2d6e]">¥0</span>
              <span className="text-gray-400 ml-1">/年</span>
            </div>
            <ul className="space-y-3 mb-8">
              {[
                '管理 1 位儿童',
                '设置 20 条奖惩规则',
                '5 条积分兑换规则',
                '每周 10 次 AI 对话',
                '基础数据统计',
                '展示广告'
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-100">
                    <i className={`${i < 4 ? 'ri-check-line text-gray-500' : 'ri-close-line text-gray-300'} text-xs`}></i>
                  </div>
                  <span className={i >= 4 ? 'text-gray-300' : ''}>{item}</span>
                </li>
              ))}
            </ul>
            <button className="whitespace-nowrap w-full py-3 border-2 border-gray-200 text-gray-600 rounded-2xl font-medium hover:border-[#1a56db] hover:text-[#1a56db] transition-colors cursor-pointer">
              免费使用
            </button>
          </div>

          <div className="flex-1 bg-gradient-to-br from-[#0a1a4a] via-[#0d2d6e] to-[#1a56db] rounded-3xl p-8 relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-400 to-orange-400 text-white text-xs font-bold px-3 py-1 rounded-full">推荐</div>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/5 rounded-full"></div>
            <div className="absolute -top-10 -left-10 w-32 h-32 bg-white/5 rounded-full"></div>
            <div className="mb-6 relative z-10">
              <span className="bg-gradient-to-r from-amber-400 to-orange-400 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 w-fit">
                <i className="ri-vip-crown-fill"></i>
                VIP 会员
              </span>
            </div>
            <div className="mb-6 relative z-10">
              <span className="text-5xl font-black text-white">¥98</span>
              <span className="text-white/50 ml-1">/年</span>
              <div className="text-white/40 text-sm mt-1">平均每天不到 2 毛钱</div>
            </div>
            <ul className="space-y-3 mb-8 relative z-10">
              {[
                '无限儿童管理',
                '无限奖惩规则',
                '无限兑换规则',
                '无限 AI 对话次数',
                '高级数据分析',
                '完全无广告',
                '激励市场优先权',
                '专属客服支持'
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-sm text-white/90">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-amber-400/20">
                    <i className="ri-check-line text-amber-300 text-xs"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <button className="whitespace-nowrap w-full py-3 bg-gradient-to-r from-amber-400 to-orange-400 text-white rounded-2xl font-bold hover:shadow-lg hover:scale-[1.02] transition-all cursor-pointer relative z-10">
              立即升级 VIP
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
